module.exports = __webpack_public_path__ + "static/media/copyText.8c88984e.svg";